<template>
  <div class="field" :class="{ 'field--flush': flush }">
    <label v-if="label" class="lbl" :for="inputId">
      {{ label }}<span v-if="requiredMark" aria-hidden="true"> *</span>
    </label>
    <select
      :id="inputId"
      ref="select"
      v-bind="$attrs"
      :multiple="multiple || null"
      :value="multiple ? null : value"
      :class="{ 'is-invalid': !!error }"
      :aria-invalid="!!error || null"
      @change="onChange"
      @blur="$emit('blur', $event.target.value)"
      @focus="$emit('focus', $event)"
    >
      <option v-if="placeholder && !multiple" value="" disabled>{{ placeholder }}</option>
      <option
        v-for="opt in normalizedOptions"
        :key="String(opt.value)"
        :value="opt.value"
        :selected="multiple ? selectedValues.includes(String(opt.value)) : null"
      >{{ opt.label }}</option>
    </select>
    <div v-if="error" class="field-error">{{ error }}</div>
  </div>
</template>

<script>
let uid = 0

export default {
  name: 'lp-select',
  inheritAttrs: false,
  props: {
    // v-model value. An array when `multiple` is set.
    value: { type: [String, Number, Array, null], default: '' },
    // Accepts ['A','B'] or [{ label, value }].
    options: { type: Array, default: () => [] },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    error: { type: String, default: '' },
    requiredMark: { type: Boolean, default: false },
    flush: { type: Boolean, default: false },
    id: { type: String, default: '' },
    // Render a native multi-select; emits an array of the selected values.
    multiple: { type: Boolean, default: false },
  },
  data() {
    return { autoId: `lp-select-${++uid}` }
  },
  computed: {
    inputId() { return this.id || this.autoId },
    normalizedOptions() {
      return this.options.map(o =>
        (o !== null && typeof o === 'object')
          ? { label: o.label, value: o.value }
          : { label: o, value: o }
      )
    },
    // Current selection as an array of strings, for matching <option> values.
    selectedValues() {
      if (Array.isArray(this.value)) return this.value.map(String)
      return (this.value === null || this.value === '') ? [] : [String(this.value)]
    },
  },
  methods: {
    onChange(event) {
      if (this.multiple) {
        this.$emit('input', Array.from(event.target.selectedOptions).map(o => o.value))
      } else {
        this.$emit('input', event.target.value)
      }
    },
  },
}
</script>
